var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"datafiles-container"},[_c('div',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t("project.dataFiles")))]),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("project.noDataFiles")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }